module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img_2.fea928ab.png";